<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">
    
    <el-tabs v-model="activeTab" v-if="type == 'mobile'" @tab-click="tabClick">
      <el-tab-pane label="手机管理员" name="list"></el-tab-pane>
      <el-tab-pane label="盘点记录" name="stock"></el-tab-pane>
      <el-tab-pane label="库存" name="order"></el-tab-pane>
      <el-tab-pane label="设置" name="setting"></el-tab-pane>
    </el-tabs>
    
    <!--添加管理员-->
    <div class="common-level-rail" v-if="(type == 'mobile' && activeTab =='list') ||(type =='pc' || type =='')">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/auth/user/add'">添加管理员</el-button></el-form-item>
        <el-form-item label="用户名" style="margin-left: 50px"><el-input v-model="formInline.user_name" placeholder="请输入用户名或姓名"></el-input></el-form-item>
       
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
    
      
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content" v-if="(type == 'mobile' && activeTab =='list') || (type =='pc' || type =='')">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shop_user_id" label="管理员ID"></el-table-column>
          <el-table-column prop="name" label="用户名/姓名">
            <template slot-scope="scope">
              {{scope.row.user_name}} <br/>
              {{scope.row.real_name}} <br/>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="role.role_name" label="所属角色">
            <template slot-scope="scope">
              <div v-if="scope.row.is_super == 0">
                <span class="mr10 green" v-for="(item, index) in scope.row.userRole" :key="index">{{ item.role.role_name }}</span>
              </div>
              <div class="gray" v-if="scope.row.is_super == 1">
                超级管理员
              </div>
            </template>
          </el-table-column>


          <el-table-column  label="盘点记录" v-if="type == 'mobile'">
            <template slot-scope="scope">
            
              <el-button size="small" type="primary" @click="q_stock(scope.row.mobile)" :disabled="loading">查看</el-button>
            </template>

          </el-table-column>


          
          <el-table-column  label="库存" v-if="type == 'mobile'">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="q_chuhuo(scope.row.mobile)" :disabled="loading">查看</el-button>
          
            </template>

          </el-table-column>




          <el-table-column  label="是否能下单" v-if="type == 'mobile'">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_buy" active-color="#13ce66" inactive-color="#ff4949"
               @change="isDefaultChange(scope.row)"></el-switch>
          
            </template>

          </el-table-column>

          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-if="scope.row.is_super < 1" @click="editClick(scope.row)" type="text" size="small" v-auth="'/auth/user/edit'">编辑</el-button>
              <el-button v-if="scope.row.is_super < 1" @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/auth/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>


    <div v-if="type == 'mobile' && activeTab =='setting'">
      <div class="user">
    <el-form size="small" ref="setting" :model="setting" label-width="150px">
      <div class="common-form">业务员设置</div>
        <el-form-item label="是否开启业务员设置" >
          <el-switch v-model="setting.is_open"></el-switch>
        </el-form-item>

        <el-form-item label="不出货sku数量" prop="num" :rules="[{required: true,message: ' '}]">
          <el-input v-model="setting.num" type="number" min=10 max=100 class="max-w460"></el-input>
        </el-form-item>


        <el-form-item label="多少天不出货，禁用下单接口" prop="days" :rules="[{required: true,message: ' '}]">
          <el-input v-model="setting.days" type="number" min=10 class="max-w460"></el-input>
        </el-form-item>

        <div class="common-form">同步一物一码设置</div>   
        <!-- <el-form-item label="只更新这个时间以后的数据" prop="days" :rules="[{required: true,message: ' '}]">
     
        <el-date-picker
                    v-model="setting.udays"
                    align="right"
                    type="datetime"
                    placeholder="选择日期时间"
                      format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    >
                  </el-date-picker>
      </el-form-item> -->

      <el-form-item label="请求网址" prop="website" :rules="[{required: true,message: ' '}]">
        <el-input v-model="setting.website" type="text" min=10 class="max-w460"></el-input>
      </el-form-item>  

      <el-form-item label="账户" prop="account" :rules="[{required: true,message: ' '}]">
        <el-input v-model="setting.account" type="text" min=10 class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="密钥" prop="secret" :rules="[{required: true,message: ' '}]">
        <el-input v-model="setting.secret" type="password" min=10 class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="被访问方app_id" prop="r_api_id" :rules="[{required: true,message: ' '}]">
        <el-input v-model="setting.r_api_id" type="text" min=10 class="max-w460"></el-input>
      </el-form-item>


      <!-- <el-form-item label="查询间隔" prop="interval" :rules="[{required: true,message: ' '}]">
        <el-input v-model="setting.interval" type="number" min=10 class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="每次更新数量" prop="num" :rules="[{required: true,message: ' '}]">
        <el-input v-model="setting.num" type="number" min=10 max=100 class="max-w460"></el-input>
        <div>最大更新100条</div>
      </el-form-item> -->


    </el-form>

      


    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="save" :disabled="loading">保存</el-button>
    </div>
  </div>

    </div>




    <div class="common-seach-wrap" v-if="type == 'mobile' && activeTab =='stock'">
      <el-form size="small" :inline="true" :model="formInlineStock" class="demo-form-inline">
       
        <el-form-item label="商城">
          <el-select size="small" v-model="formInlineStock.app_id" placeholder="请选择">
            <el-option 
            v-for="(item,index) in app" :key="index" 
            :label="item.app_name" 
            :value="item.app_id"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="">
          <el-input v-model="formInlineStock.product_search" placeholder="请输入产品名称/sku条形码"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-input v-model="formInlineStock.op_user_search" placeholder="请输入业务员"></el-input>
        </el-form-item>

        
        <el-form-item label="">
          <el-input v-model="formInlineStock.op_shop_user_search" placeholder="请输入后端编辑人员昵称"></el-input>
        </el-form-item>

  
     
     
       <el-form-item label="类型">
          <el-select size="small" v-model="formInlineStock.code" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="销售" value="sold"></el-option>
            <el-option label="一物一码同步" value="sync"></el-option>
            <el-option label="盘点" value="check"></el-option>
        
          </el-select>
        </el-form-item>
  
        <el-form-item label="增加/减少">
          <el-select size="small" v-model="formInlineStock.type" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="增加" :value="1"></el-option>
            <el-option label="减少" :value="2"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmitStock">查询</el-button>
          <el-button type="primary" style="background: #c6c6c6;border: none;" @click="reastStock">重置</el-button>
   
          
          <!-- <el-button type="primary" @click="sync('barcode')">同步出货记录</el-button> -->
          <!-- <el-button type="primary" @click="sync('salesperson')">同步业务员</el-button>
          <el-button type="primary" @click="sync('user')">同步用户</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content" v-if="type == 'mobile' && activeTab =='stock'">
      <el-form ref="form" :model="formStock" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableDataStock" border style="width: 100%" v-loading="loading">
            <el-table-column prop="sku_stock_id" label="ID" > </el-table-column>

           
            <el-table-column prop="app.app_name" label="商城名称" > </el-table-column>
            <!-- <el-table-column prop="product.product_no" label="产品条形码" > </el-table-column> -->
            <el-table-column prop="product.product_name" label="产品名称" > </el-table-column>
            <el-table-column prop="product.product_sku.product_no" label="产品SKU条形码" > </el-table-column>
            <el-table-column prop="product.product_sku.product_attr" label="产品规格" > </el-table-column>
            


             
            <el-table-column prop="code" label="类型" > 
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.code=='sold'">销售</span>
                <span v-if="scope.row.code=='sync'">一物一码同步</span> -->
                <span v-if="scope.row.code=='check'">盘点</span>

            </template>
            </el-table-column>
            
            <el-table-column prop="type" label="增加/减少" > 
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">增加库存</span>
                <span v-if="scope.row.type==2">减少库存</span>

            </template>
            </el-table-column>

            <el-table-column prop="original_num" label="原库存" >
              <template slot-scope="scope" >
                <span  style="font-size: 16px; ">{{ scope.row.original_num }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="change_num" label="变动库存" >
              <template slot-scope="scope"  >
        
                <span v-if="scope.row.type==1" style="font-size: 16px; color: #006846;">+{{ scope.row.change_num }}</span>
                <span v-if="scope.row.type==2" style="font-size: 16px;color: #ff0000;">{{ scope.row.change_num }}</span>
              </template>
            </el-table-column>

            
            <el-table-column prop="num" label="最终库存" >
              <template slot-scope="scope">
                <span style="font-size: 16px; ">{{ scope.row.num }}</span>
          

              </template>
            </el-table-column>

    
            <el-table-column prop="opUser.nickName" label="前端最后编辑人员"></el-table-column>
            <el-table-column  label="后端最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opShopUser &&  scope.row.opShopUser.user_name">{{ scope.row.opShopUser.user_name }}
                <span v-if=" scope.row.opShopUser.real_name">({{ scope.row.opShopUser.real_name }})</span>
                </div>
              </template>
              </el-table-column>

              <el-table-column prop="remark" label="备注" > </el-table-column>

              <el-table-column prop="update_time" label="最后修改时间" ></el-table-column>
 
            <el-table-column prop="create_time" label="创建时间" ></el-table-column>
 
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChangeStock" @current-change="handleCurrentChangeStock" background :current-page="curPageStock"
           :page-size="pageSizeStock" layout="total, prev, pager, next, jumper"
          :total="totalDataNumberStock">
        </el-pagination>
      </div>
    </div>






    <div class="common-seach-wrap"  v-if="type == 'mobile' && activeTab =='order'">
      <el-form size="small" :inline="true" :model="formInlinePsin" class="demo-form-inline">
       

        <el-form-item label="">
          <el-input v-model="formInlinePsin.buser_search" placeholder="请输入名称/昵称"></el-input>
        </el-form-item>


        <el-form-item label="业务员">
          <el-select size="small" v-model="formInlinePsin.buser_search" @change="chageClick" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item,index) in sales_arr" :key="index" :label="item.name" :value="item.mobile"></el-option>
            
          </el-select>
        </el-form-item>

        <el-form-item label="类型">
          <el-select size="small" v-model="formInlinePsin.type" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="仓库到业务员" :value="1"></el-option>
            <el-option label="业务员到门店" :value="2"></el-option>
            <el-option label="货调到业务员" :value="3"></el-option>
            <el-option label="仓库到货调" :value="4"></el-option>
          </el-select>
        </el-form-item>
    

        <el-form-item label="是否收货">
          <el-select size="small" v-model="formInlinePsin.is_receipt" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未收货" :value="0"></el-option>
            <el-option label="已收货" :value="1"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmitPsin">查询</el-button>
     

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="reast">重置</el-button>
     

        </el-form-item>


        <!-- <div>
          <el-form-item label="">
          <el-input v-model="sales_mpobie" placeholder="同步的业务员手机号"></el-input>
        </el-form-item>
        <el-form-item >  
          <el-button type="primary" @click="sync('sales_barcode')">同步一物一码进货记录</el-button>
          <el-button type="primary" @click="sync('sales_c_barcode')">同步一物一码出货记录</el-button>
        </el-form-item>
        </div> -->
   
      </el-form>
    </div>
    <div class="product-content" v-if="type == 'mobile' && activeTab =='order'">
      <div>
    
        <table border cellspacing="0" class="mt10" style="border: 1px solid #F6F8FB;">
             <tr style="border: 1px solid #F6F8FB;padding:10px;">
              <th class="w150" style="border: 1px solid #F6F8FB;padding:10px;" >进货人：</th>
               <th class="w150" style="border: 1px solid #F6F8FB;padding:10px;" >进货：</th>
               <th class="w150" style="border: 1px solid #F6F8FB;padding:10px;" >出货人：</th>
               <th class="w150" style="border: 1px solid #F6F8FB;padding:10px;">出货（门店未收货）：</th>
               <th class="w150" style="border: 1px solid #F6F8FB;padding:10px;">出货（门店已收货）：</th>
             </tr>
             <tr>
              <td class="tc" style="border: 1px solid #F6F8FB;padding:10px;">{{ psin_val.name }} </td>
              <td class="tc" style="border: 1px solid #F6F8FB;padding:10px;">{{ psin_val.count_one }} </td>
              <td class="tc" style="border: 1px solid #F6F8FB;padding:10px;">{{ psin_val.cname }} </td>
              <td class="tc" style="border: 1px solid #F6F8FB;padding:10px;">{{ psin_val.count_two }} </td>
              <td class="tc" style="border: 1px solid #F6F8FB;padding:10px;" >{{ psin_val.count_three }} </td>
             </tr>
            
           </table>


      </div>
    
      
      <el-form ref="form" :model="formPsin" label-width="100px" style="margin-top: 10px;">
        <div class="table-wrap">
          <el-table size="small" :data="tableDataPsin" border style="width: 100%" v-loading="loading">
            <el-table-column prop="id" label="ID" > </el-table-column>


            <el-table-column prop="nick_name" label="发起人" >
              <template slot-scope="scope">
                <span v-if="scope.row.fname">{{ scope.row.fname }}</span>
              </template>
            </el-table-column>
         
            <el-table-column prop="nick_name" label="接收人" >
              <template slot-scope="scope">
                <span v-if="scope.row.name">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="mobile" label="手机号" >
              <template slot-scope="scope">
                <span v-if="scope.row.mobile">{{ scope.row.mobile }}</span>
              </template>
            
            </el-table-column> -->

            <el-table-column prop="goods_name" label="产品名称" > </el-table-column>
            <el-table-column prop="goods_spec" label="产品规格" > </el-table-column>
            <el-table-column prop="count" label="数量" > </el-table-column>
            <!-- <el-table-column prop="price" label="价格" > </el-table-column> -->
            <!-- <el-table-column prop="product_price" label="产品价格" > </el-table-column> -->

              <el-table-column prop="bar_code" label="条形码" > </el-table-column>
            <!--  <el-table-column prop="product_bar_code" label="产品条形码" > </el-table-column> -->

            <el-table-column prop="type" label="类型" > 
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">仓库到业务员</span>
                <span v-if="scope.row.type==2">业务员到门店</span>
                <span v-if="scope.row.type==5">货调到业务员</span>
                <span v-if="scope.row.type==4">仓库到货调</span>
                <!-- <span v-if="scope.row.type==3">生产到仓库</span>
                <span v-if="scope.row.type==4">仓库到货调</span>
              
                <span v-if="scope.row.type==6">仓库调货给仓库</span> -->
            </template>
            </el-table-column>

            <el-table-column v-if="formInlinePsin.type == 2" prop="is_receipt" label="是否收货" >
              <template slot-scope="scope">
                <span v-if="scope.row.type == 2 &&  scope.row.is_receipt==0">未收货</span>
                <span v-if="scope.row.type == 2 && scope.row.is_receipt==1">已收货</span>
    
            </template>
            </el-table-column>


            <el-table-column v-if="formInlinePsin.type == 2" prop="app.app_name" label="所属商城" > </el-table-column>

            <el-table-column prop="create_time" label="创建时间" > </el-table-column>
            <!-- <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small" >详情</el-button>
              </template>
          </el-table-column> -->

            <!-- <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
             -->
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChangePsin" 
        @current-change="handleCurrentChangePsin" 
        background :current-page="curPagePsin"
           :page-size="pageSizePsin" layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumberPsin">
        </el-pagination>
      </div>
    </div>




    <Add v-show="open_add"  :open="open_add" :type="type"  @close="closeAdd"></Add>

    <Edit v-show="open_edit" :open="open_edit" :type="type"  :shop_user_id="curModel.shop_user_id"  @close="closeEdit"></Edit>

  </div>
</template>

<script>
import AuthApi from '@/api/auth.js';
import PsinApi from '@/api/psin.js';
import Add from './dialog/Add.vue';
import Edit from './dialog/Edit.vue';
export default {
  components: {
    Add,
    Edit
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user_name: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      curModel: {},
      // type 类型
      type:"",//pc 后台  mobile  手机端

      activeTab:"list",
      setting:{
        is_open:false,
        num:10,
        days:3,
        udays:"",
        interval:60,
        num:1,
        secret:"",
        account:"",
        r_api_id:"",
        website:"http://kmdapi.gzkcyj.com/",
      },



       /*列表数据*/
       tableDataPsin: [],
      /*一页多少条*/
      pageSizePsin: 20,
      /*一共多少条数据*/
      totalDataNumberPsin: 0,
      /*当前是第几页*/
      curPagePsin: 1,
      formPsin: {},
      formInlinePsin:{
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        is_receipt:-1,
        type:-1,
      },
      psin_val:{

      },
      sales_mpobie:"",
      sales_arr:[],



      formInlineStock: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        is_receipt:-1,
        op_shop_user_search:"",
        op_user_search:"",
        app_id:-2
      },
      /*列表数据*/
      tableDataStock: [],
      /*一页多少条*/
      pageSizeStock: 20,
      /*一共多少条数据*/
      totalDataNumberStock: 0,
      /*当前是第几页*/
      curPageStock: 1,
      formStock:{},
      app:[]
    };
  },
  created() {
    /*获取列表*/
    this.type = '';
    if(this.$route.query.type){
      this.type = this.$route.query.type;
    }
    this.getTableList();

   

  },
  watch: {
        // 利用watch方法检测路由变化：
        $route: function (to, from) {
          this.type = '';
           if(to.query.type && to.query.type.length > 0){
              this.type = to.query.type;
              this.getTableList();
            }else{
              this.getTableList();
            }
           
        }
    },
  methods: {
    getApp(){
      let self = this;
      let Params = {};

      PsinApi.getApp(Params, true)
        .then(data => {

          self.app = data.data;
          

        })
        .catch(error => {});
    }, 
    chageClick(){
      this.getPsinTableList()
    },
    q_stock(mobile){
      this.activeTab = 'stock';
      this.formInlineStock.op_user_search = mobile;
      this.getPsinTableList()

    },
    q_chuhuo(mobile){
      this.activeTab = 'order';
      this.formInlinePsin.buser_search = mobile;
      this.getPsinTableList()
    },
    tabClick(){
      if(this.activeTab == 'setting'){
        this.getSetting()
    }
    if(this.activeTab == 'order'){
      this.getPsinTableList()
      this.getSalesArr();
    }

    if(this.activeTab == 'stock'){
      this.getApp();
      this.getTableListStock();
    }
      
    },
    reast(){
      this. formInlinePsin = {
          buser_search:"",
          order_search:"",
          user_search:"",
          is_ratio:-1,
          code:"",
          is_receipt:-1,
          type:-1,
        };
      this.curPagePsin = 1;
      this.getPsinTableList();
    },
      /* 设置默认 */
      isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let is_buy = 1;
        if(row.is_buy){
          is_buy = 1;
        }else{
          is_buy = 0;
        }
        self.loading = true;
        AuthApi.setIsBuyDefault({shop_user_id: row.shop_user_id,is_buy:is_buy}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_buy = !row.is_buy
      })
    },

      /*获取设置*/
      getSetting() {
      let self = this;
      let Params = {};
      AuthApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.setting = data.data.vars.values;
       
        })
        .catch(error => {});
    },

    /*点击保存*/
    save() {
      let self = this;
      let params = self.setting;
      self.loading = true;
      AuthApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },


    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList(searchParams='') {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.type
      if(searchParams!=''){
        Params.user_name = searchParams;
      }
      AuthApi.userList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

   
    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let searchParams = self.formInline.user_name;
      self.getTableList(searchParams);
    },

    /*打开添加*/
    addClick() {
      this.open_add=true;
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*打开编辑*/
    editClick(row) {
      this.curModel=row;
      this.open_edit=true;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          AuthApi.userDelete(
            {
              shop_user_id: row.shop_user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，该管理员删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },



     /*获取列表*/
     getPsinTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInlinePsin;
      Params.page = self.curPagePsin;
      Params.list_rows = self.pageSizePsin;
      self.loading = true;

      PsinApi.getYwymBm(Params, true)
        .then(data => {
          self.loading = false;
          self.tableDataPsin = data.data.list.data;
          self.psin_val =  data.data.list.psin_val;
          self.totalDataNumberPsin = data.data.list.total;
       
        })
        .catch(error => {});
    },
    getSalesArr(){
      let self = this;
      let Params = {};
      self.loading = true;

      PsinApi.getSalesArr(Params, true)
        .then(data => {
          self.loading = false;
          self.sales_arr = data.data.salesArr;
       
        })
        .catch(error => {});
    },

     /*选择第几页*/
     handleCurrentChangePsin(val) {
      this.curPagePsin = val;
      this.getPsinTableList();
    },

    /*每页多少条*/
    handleSizeChangePsin(val) {
      this.curPagePsin = 1;
      this.pageSizePsin = val;
      this.getPsinTableList();
    },
    /*搜索查询*/
    onSubmitPsin() {
      this.curPage = 1;
      this.getPsinTableList();
    },
    sync(code){
        var self = this;
        //跳转同步页面 同步一物一码记录
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let url = baseUrl + '/index.php/job/ApiSync/run?app_id=10016&code='+code+"&salesmobile="+self.sales_mpobie;
        window.open(url)
    },



     /*选择第几页*/
     handleCurrentChangeStock(val) {
      this.curPage = val;
      this.getTableListStock();
    },

    /*每页多少条*/
    handleSizeChangeStock(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableListStock();
    },
       /*获取列表*/
       getTableListStock() {
      let self = this;
      console.log("------")
      let Params = this.formInlineStock;
      Params.page = self.curPageStock;
      Params.list_rows = self.pageSizeStock;
      self.loading = true;

      PsinApi.skuStock(Params, true)
        .then(data => {
          self.loading = false;
          self.tableDataStock = data.data.list.data;
          self.totalDataNumberStock = data.data.list.total;
        })
        .catch(error => {});
    },
      /*搜索查询*/
      onSubmitStock() {
      this.curPage = 1;
      this.getTableListStock();
    },
    reastStock(){
      this.formInlineStock = {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        is_receipt:-1,
        op_shop_user_search:"",
        op_user_search:"",
        app_id:-2
      }
      this.getTableListStock();
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/auth/user/index.vue